import { IRM } from './root/IRM';
import { DevMenu } from './dev/DevMenu';

const App = () => (
    <>
        <IRM />
        <DevMenu />
    </>
);

export default App;
